import dayjs from '../utils/dayjs';

/********************************************** *
 * list of all functions include: 
 * isSomething => check if is something
 * parseSomething => Parse something ...
 * getSomething => Get Something ...
********************************************** */

import helper_is from './is';
import helper_get from './get';
import helper_parse from './parse';


import __ from 'languages/index';

type NonFunctional<T> = T extends Function ? never : T;


/**
 * Helpers
 */


class helpers {

  /**
   * Caculate percent, 
   * @input target: number, got: number
   * @return number * 100
   */
  caculatePercent(target: number | string, got: number | string): number {
    target = Number(target);
    got = Number(got);
    let r = ((got / target) * 100).toFixed(1);
    let rr = parseFloat(r);
    if (rr > 100) rr = 100;
    return rr;
  }

  // constructor() {}
  /**
   * Filter object, null or undefined is ignore
   * @param _self 
   * @returns 
   */
  filterNullObject(_self: any) {
    var result: any = {};
    for (var key in _self) {
      /**
       * Địt mẹ Javascript, cái địt tổ nó, đổi sang 
       * _self[key] !== null nó lại không được, phải 
       * _self[key] === null cơ! null === null
       */
      if (_self[key] === null || _self[key] === undefined) continue;
      result[key] = _self[key];
    }
    return result;
  }



  /**
   * Pick variable from Object, like lodash/pick
   * @Param _object: object
   * @Param _PickArray: array to pick from Object
   * @McJamBi  from Jamviet.com
   * @DateTime 2021-10-06T02:22:20+0700
   */
  pick(_object: any, _PickArray: string[]) {
    let ALLOW_VARIABLE: any = {};
    for (let query_string in _object) {
      if (_PickArray.indexOf(query_string) > -1) {
        ALLOW_VARIABLE = { ...ALLOW_VARIABLE, ...{ [query_string]: _object[query_string] } };
      }
    }
    return ALLOW_VARIABLE;
  }



  /**
   * Removes fields with an 'id' field that equals ''.
   * This function was created to prevent entities to be sent to
   * the server with an empty id and thus resulting in a 500.
   *
   * @param entity Object to clean.
   */
  cleanEntity<T>(entity: T): T {
    const keysToKeep = Object.keys(entity).filter(k => !(entity[k] instanceof Object) || (entity[k]['id'] !== '' && entity[k]['id'] !== -1));
    return this.pick(entity, keysToKeep);
  }


  /**
   * Return filter to save to history ...
   * @param stringQuery Object to URL query function
   * @returns 
   */
  buildEndUrl(stringQuery: any) {
    if (stringQuery === void 0) return '?query=';
    const params = [];
    for (let key in stringQuery) {
      let nameofquery = String(key || '').trim();
      let valueofquery = stringQuery[key] != null ? String(stringQuery[key]).trim() : '';
      if (nameofquery !== '')
        params.push({ key: nameofquery, value: valueofquery });
    }
    if (params.length > 0) {
      return '?' + params.map(({ key, value }) => `${key}=${value}`).join('&');
    }

    return '?query=';
  };



  /**
   * Revert buildEndUrl, parse URL to Object
   * Duplicate value will be overwrite, last value will taken
   * @param stringQuery URL SEARCH STRING
   */
  ExtractUrl(stringQuery: any): {
    [propKey: string]: string
  } {
    let searchParams = new URLSearchParams(stringQuery);
    let final_object = {};
    for (const [key, value] of searchParams.entries()) {
      final_object = {
        ...final_object, ...{
          [key]: value
        }
      }
    }
    return final_object;

    // let URLWithoutQuestionMark = String(stringQuery).substr(1); // remove ? at beginer of string
    // let URLToObject = String(URLWithoutQuestionMark).split('&'); // array
    // let FN = URLToObject.map( (r) => {
    //     let a = String(r).split('=');
    //     let y = { [a[0]] : a[1] };
    //     return y;
    // });

    // if ( FN ) {
    //   let final_object = {};
    //   for ( var a of FN) {
    //     final_object = {...final_object, ...a};
    //   }
    //   return final_object;
    // }
    // return {};
  }

  /**
   * Caculate percentage
   * @param partialValue Number
   * @param totalValue Number
   * @returns 
   */
  percentage(partialValue: number, totalValue: number) {
    partialValue = Number(partialValue);
    totalValue = Number(totalValue);
    if (totalValue === 0) return 0;
    return ((100 * partialValue) / totalValue).toFixed(2);
  }


  // lodash debounce ...
  debounce(callback: any, wait: number) {
    let timeoutId = null;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
  }

  /**
   * Filter empty element in an array, remove empty string, null and undefined
   * @param _array array or null
   */
  filterEmptyArray<T>(_array: T[]): T[] | [] {
    if (!Array.isArray(_array)) return [];

    let __array = _array?.filter((el) => {
      return el !== '' && el !== 'undefined' && el !== undefined && el !== null;
    });
    return __array;
  }

  /**
   * Filter empty element in an object, remove empty string, null and undefined
   * @param object object
   */
  filterEmptyObject<T>(_object: T): T {
    let final_after_filter: T;
    for (let property in _object) {
      let val = _object[property];
      if (val === '' || val === undefined || val === null) continue;

      final_after_filter = {
        ...final_after_filter, ...{
          [property]: val
        }
      }
    }
    return final_after_filter;
  }

  /** 
   * Xóa bỏ tất thảy các phần tử trùng lặp trong array
   */
  uniqueArray(_array: string[] | number[] | bigint[]) {
    function onlyUnique(value, index, array) {
      return array.indexOf(value) === index;
    }
    return _array.filter(onlyUnique);
  }

  /**
   * Trim middle string, eg: Hello xin chào...nhé bạn!
   * @param s String
   */
  trimMiddleString(input_string: string, front?: number, back?: number): string {
    if (input_string === void 0) return '';
    if (!input_string) return '';
    if (front === void 0) front = 10;
    if (back === void 0) back = 10;
    if (input_string.length < 21) return input_string;

    let start = String(input_string || ' ').substring(0, front);
    let end = String(input_string || ' ').substring(input_string.length - back);

    return `${start} ...${end}`;

  }


  /**
   * Trim content string, eg: Hello xin chào...
   * @param s String
   */
  trimContentString(s: string, _length?: number): string {
    if (s === void 0) return '';
    if (!s) return '';
    if (_length === void 0) _length = 20;
    if (s.length < 21) return s;

    let start = String(s || ' ').substring(0, _length);

    return `${start}...`;
  }



  /**
   * Convert Bytes to KB, MB, GB
   * @param bytes 
   * @param decimals 
   * @returns 
   */
  bytesToSize(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    if (i < 0) i = 0;
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i] || 'Bytes';
  }



  /**
   * Convert DateTime bigInt to number of days remain
   * Tính số ngày đã trôi qua, dương là số ngày trôi qua, số âm là chưa tới ngày
   * @param thatday bigint
   * @returns 
   */
  subtractDate = (thatday: any, prefix?: string) => {
    if (!thatday || thatday < 1) return '';
    const elapsedDays = dayjs().diff(dayjs(Number(thatday)), 'day', true);
    return Math.ceil(elapsedDays) + (prefix ? ' ' + prefix : '');
  }


  /** 
   * Trả về thời gian đầu ngày và cuối ngày dạng timestamp
   * @input Date
   */
  getDayRange(date: Date): { start: number; end: number } {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);

    const end = new Date(date);
    end.setHours(23, 59, 59, 999);

    return {
      start: start.getTime(), // timestamp ms
      end: end.getTime(),
    };
  }



  /**
   * Show the date / or hour or minutes passed
   * @param thatday Date object
   * @param prefix 
   * @returns 
   */
  subtractTimeHistory = (timestamp: Number | String, default_value?: string): string => {
    if (!timestamp) return default_value;

    const timestampInSaigon = dayjs(Number(timestamp));
    const elapsedSeconds = dayjs().diff(timestampInSaigon, 'second', true);

    if (elapsedSeconds < 59) {
      return Math.ceil(elapsedSeconds) + ' ' + __('second_ago');
    }
    if (elapsedSeconds / 60 < 59) {
      return Math.ceil(elapsedSeconds / 60) + ' ' + __('minute_ago');
    }

    if (elapsedSeconds / 3600 < 24) {
      return Math.ceil(elapsedSeconds / 3600) + ' ' + __('hour_ago');
    }

    if (elapsedSeconds / 86400 < 30) {
      return Math.ceil(elapsedSeconds / 86400) + ' ' + __('day_ago');
    }

    return dayjs(new Date(Number(timestamp))).format('YYYY/MM/DD HH:mm');
  }



  /** Convert ngày sang năm tháng ngày ... */
  subtractTimeHistoryDurationDays(totalDays: number): string {
    totalDays = Math.floor(totalDays);

    if (totalDays <= 0) {
      return '0 ngày';
    }

    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = totalDays % 30;

    const parts: string[] = [];

    if (years > 0) {
      parts.push(`${years} năm`);
    }

    if (months > 0) {
      parts.push(`${months} tháng`);
    }

    if (days > 0) {
      parts.push(`${days} ngày`);
    }

    return parts.join(' ');
  }



  /**
   * Helper to produce an array of enum values.
   * @param enumeration Enumeration object.
   */
  enumToArray<T extends object>(enumeration: T): NonFunctional<T[keyof T]>[] {
    return Object.keys(enumeration)
      .filter(key => isNaN(Number(key)))
      .map(key => (enumeration as Record<string, NonFunctional<T[keyof T]>>)[key])
      .filter(val => typeof val === "number" || typeof val === "string");
  }



  /**
   * Convert comma to array
   * @param __str String with comma, safe function
   * @return any[] or empty []
   */
  commaToArray(__str: string): any[] {
    try {
      return String(__str || " ").split(',').map(el => el.trim());
    } catch (_e) {
      return [];
    }
  }


  /**
   * Convert array to comma
   * @param __str array
   * @return string with comma
   */
  ArrayToComma(__str: any[]): string {
    try {
      return __str.join(',');
    } catch (_e) {
      return '';
    }
  }


  /**
   * Format for money or you need something like easy to read long number
   * @param x 
   * @returns 
   */
  formatNumberWithCommas(n: string | number): string {
    n = this.parseNumeric(n);
    let isNegative = false;

    if (n < 0) {
      isNegative = true;
      n = Math.abs(n);
    }

    n = n.toString();
    var pattern = /(\d+)(\d{3})/;
    while (pattern.test(n)) {
      n = n.replace(pattern, "$1,$2");
    }


    return isNegative ? '-' + n : n;
  }
  /**
   * Đặt giá trị cookie (đã mã hóa).
   * @param name Tên cookie
   * @param value Giá trị cookie
   * @param expire_day Số ngày hết hạn
   * @param use_secure Dùng cờ Secure (nên bật nếu website là HTTPS)
   */
  cookie_set(name: string, value: string, expire_day = 7, use_secure = true): void {
    let expires = '';
    // Tính toán ngày hết hạn
    if (expire_day) {
      const d = new Date();
      d.setTime(d.getTime() + (expire_day * 24 * 60 * 60 * 1000));
      expires = ";expires=" + d.toUTCString();
    }

    // Thêm cờ Secure nếu cần
    const secure_flag = use_secure ? ";Secure" : "";

    // Mã hóa giá trị trước khi lưu
    const encoded_value = encodeURIComponent(value);

    document.cookie = `${name}=${encoded_value};SameSite=Lax;path=/` + expires + secure_flag;
  }

  /**
   * Lấy giá trị cookie (tự động giải mã).
   * @param name Tên cookie
   * @returns Giá trị cookie (string) hoặc undefined nếu không tìm thấy.
   */
  cookie_get(name: string): string | undefined {
    // Cách 1: Dùng Regex (khuyến nghị vì rõ ràng hơn)
    const matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));

    if (!matches) {
      return undefined;
    }

    // Lấy group 2 (giá trị) và giải mã
    return decodeURIComponent(matches[1]);

    /* // Cách 2: Sửa lại code gốc của bạn (vẫn dùng let/const và decode)
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length >= 2) {
      const cookie_value = parts.pop()?.split(";").shift();
      return cookie_value ? decodeURIComponent(cookie_value) : undefined;
    }
    return undefined;
    */
  }

  /**
   * Xóa cookie.
   * @param name Tên cookie
   * @param use_secure Phải khớp với cờ Secure lúc set
   */
  cookie_delete(name: string, use_secure = true): void {
    const secure_flag = use_secure ? ";Secure" : "";
    // Cách tốt nhất để xóa là set Max-Age về 0 (hoặc số âm)
    document.cookie = `${name}=;SameSite=Lax;path=/;Max-Age=-99999999` + secure_flag;
  }


  /**
   * Colon to old sort style
   * @use in simple Filter ... for advance filter
   */
  colonToOldSort(__str: string) {
    try {
      let a = this.commaToArray(__str);
      let s = String(a.pop() || " ").split(':').map(el => el.trim());
      return s.join(', ');
    } catch (_e) {
      return '';
    }
  }

  // reserve back to old version...
  /**
   * Use for simple Filter ...
   * @param __str 
   * @returns 
   */
  oldSortToColon(__str: string) {
    try {
      let a = this.commaToArray(__str);
      return a.join(':');
    } catch (e) {
      return '';
    }
  }

  /** For people Name, example: Join Maclaren */
  capitalizeWords(text: string) {
    return text
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  /**
   * Hỗ trợ thằng chó ngu lồn shopify/react-form cho nó về trạng thái ban đầu
   * @keyword clean form, clear form, resetform
   */
  resetForm(fields: Record<string, any>) {
    Object.values(fields).forEach((field: any) => {
      if (field?.onChange) {
        field.onChange(""); // clear trắng value
      }
      if (field?.reset) {
        field.reset(); // optional: đưa trạng thái field về sạch
      }
    });
  }


  numberToTime(num: number): string {
    // Lấy giờ và phút từ số
    const hour = Math.floor(num / 100); // ví dụ 2230 -> 22
    const minute = num % 100;           // ví dụ 2230 -> 30

    // Đảm bảo luôn có 2 chữ số
    const hourStr = hour.toString().padStart(2, "0");
    const minuteStr = minute.toString().padStart(2, "0");

    return `${hourStr}:${minuteStr}`;
  }


  /**
   * Chuyển đổi phút sang full string thời gian
   * @param _minutes 
   * @returns 
   */
  minuteToFullHourString(_minutes: number | string) {
    const seconds = Number(_minutes) * 60;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return [hours > 0 ? `${hours}h` : '', minutes > 0 ? `${minutes}p` : hours > 0 ? '0p' : ''].filter(Boolean).join(' ');
  }

  /**
   * Chuyển đổi giây sang giờ phút ... full string
   * @param _minutes 
   * @returns 
   */
  secondToFullHourString(__seconds: number | string) {
    const seconds = Number(__seconds);
    if (seconds < 60) {
      return `${seconds} giây`;
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return [hours > 0 ? `${hours}h` : '', minutes > 0 ? `${minutes}p` : hours > 0 ? '0p' : ''].filter(Boolean).join(' ');
  }



}

interface helpers extends helper_is, helper_get, helper_parse { }
const __helpers = new helpers();
export default __helpers;



/*******
 * Everything after here is for webpack!
 */


// copy the methods
Object.assign(helpers.prototype, new helper_is());
Object.assign(helpers.prototype, new helper_get());
Object.assign(helpers.prototype, new helper_parse());


/**
 * It is must be here because of webpack can not run without applyMixins
 * @param derivedCtor 
 * @param constructors 
 */

// the helper function
function applyMixins(derivedCtor: any, constructors: any[]) {
  constructors.forEach((baseCtor) => {
    Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
      Object.defineProperty(
        derivedCtor.prototype,
        name,
        Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
        Object.create(null)
      );
    });
  });
}

applyMixins(helpers, [helper_is, helper_get, helper_parse]);